import { lazy } from 'react'
import locales from './locales'
import routes from './routes'
import themes from './themes'
import parseLanguages from 'base-shell/lib/utils/locale'
import { dark } from '@material-ui/core/styles/createPalette'

const config = {
  auth: {
    signInURL: '/signin',
  },
  routes,
  locale: {
    locales,
    defaultLocale: parseLanguages(['ru', 'en', 'de'], 'en'),
    // defaultLocale: parseLanguages('ru'),
    onError: (e) => {
      //console.warn(e)
      return
    },
  },
  components: {
    Loading: 'true',
    // Меню скрывается на страницах без оболочки (паспорт марки)
    Menu: lazy(() => import('../components/Menu/ShellMenu')),
  },
  menu: {
    // width: 280,

    // offlineIndicatorHeight: 12,
    // initialAuthMenuOpen: true,
    // initialMiniMode: true,
    // initialMenuOpen: true,
    // initialMobileMenuOpen: true,
    // initialMiniSwitchVisibility: true,

    MenuHeader: lazy(() => import('../components/Menu/MenuHeader')),
    MenuContent: lazy(() => import('../components/Menu/MenuContent')),
  },
  theme: {
    themes,
    mode: dark,
    defaultThemeID: 'default',
    defaultIsDarkMode: false,
    defaultIsRTL: false, //change this to true for default Right to Left Language support
  },
  pages: {
    LandingPage: lazy(() => import('../pages/LandingPage/LandingPage')),
    PageNotFound: lazy(() => import('../pages/PageNotFound/PageNotFound')),
  },
  responseTimeout: 30000,

   remote: {
     isEnabled: true, // флаг переключения между фиктивным и реальным сервером
     url: process.env.REACT_APP_BASE_API_URL // URL реального сервера
   },
}

export default config
